module.exports = __webpack_public_path__ + "img/concung_web.1b26a5e1.png";